module.exports = __webpack_public_path__ + "static/img/traffic-light-red.4d415c4.png";